module.exports = __webpack_public_path__ + "dist/img/user-doctor.768bd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-doctor.png
// module id = HJVj
// module chunks = 1